<script setup lang="ts">
import { ref } from 'vue';
import { useBreakpoints } from '@monolith/legacy/modules/design-system-candidates';
const { isBelowXl } = useBreakpoints();
const isHovered = ref(false);
</script>

<template>
  <article
    :class="['ds-flex ds-flex-col ds-h-full ds-rounded-md ds-overflow-hidden', '']"
    @mouseenter="isHovered = !isBelowXl ? true : false"
    @mouseleave="isHovered = false"
  >
    <section class="ds-relative">
      <slot
        name="topContent"
        :is-hovered="isHovered"
      />
      <menu class="ds-contents">
        <slot
          name="middleActions"
          :is-hovered="isHovered"
        />
      </menu>
    </section>
    <section class="card__bottom-content">
      <slot
        name="bottomContent"
        :is-hovered="isHovered"
      />
    </section>
    <menu :class="['ds-absolute ds-top-0 ds-left-0 ds-right-0', 'ds-flex ds-justify-between', 'ds-p-2']">
      <div class="card__topActions">
        <slot
          name="topLeftActions"
          :is-hovered="isHovered"
        />
      </div>
      <div class="card__topActions">
        <slot
          name="topRightActions"
          :is-hovered="isHovered"
        />
      </div>
    </menu>
    <menu>
      <slot
        name="bottomActions"
        :is-hovered="isHovered"
      />
    </menu>
  </article>
</template>

<style lang="scss" scoped>
@import '@css/vue-import';

.card {
  &__topActions {
    @apply ds-flex ds-gap-1 ds-flex-col;
    z-index: $z-index-catalog-card-items;
  }
  &__bottom-content {
    @apply ds-flex ds-flex-col;
    flex: 1;
  }
}
</style>
